import React, { useEffect } from 'react';
import moment from 'moment';
import styles from './../styles.module.scss';

// components
import { DatePicker, DefaultButton, Panel, PanelType, PrimaryButton, Stack } from '@fluentui/react';
import GeneralService from '../../../../services/general';
import { FilterOptionProps } from '../panel';

interface IDateFilterPanelProps {
    title?: string;
    selected: FilterOptionProps[];
    onApply(selected: FilterOptionProps[]): void;
    onCancel(): void;
}

const DateFilterPanel: React.FC<IDateFilterPanelProps> = (props: IDateFilterPanelProps) => {
    const [startDate, setStartDate] = React.useState<Date | undefined>();
    const [endDate, setEndDate] = React.useState<Date | undefined>();

    useEffect(() => {
        const startOpt = props.selected.find((s) => s.filterby === 'start_date');
        const endOpt = props.selected.find((s) => s.filterby === 'end_date');

        if (startOpt && startOpt.key) {
            setStartDate(moment(startOpt.key, 'YYYY-MM-DD').toDate());
        }
        if (endOpt && endOpt.key) {
            setEndDate(moment(endOpt.key, 'YYYY-MM-DD').toDate());
        }
    }, [props.selected]);

    const _onApply = () => {
        const filtered = props.selected.filter((s) => s.filterby !== 'start_date' && s.filterby !== 'end_date');

        if (startDate) {
            const formattedKey = moment(startDate).format('YYYY-MM-DD');
            const formattedTitle = moment(startDate).format('DD MMM YYYY');
            filtered.push({
                filterby: 'start_date',
                filterbyText: 'Start Date',
                key: formattedKey,
                title: formattedTitle
            });
        }

        if (endDate) {
            const formattedKey = moment(endDate).format('YYYY-MM-DD');
            const formattedTitle = moment(endDate).format('DD MMM YYYY');
            filtered.push({
                filterby: 'end_date',
                filterbyText: 'End Date',
                key: formattedKey,
                title: formattedTitle
            });
        }

        props.onApply(filtered);
    }

    return (
        <Panel
            headerText={props.title || "Filter by Date"}
            isOpen={true}
            type={PanelType.medium}
            onDismiss={() => props.onCancel()}
            isFooterAtBottom={true}
            onRenderFooterContent={() => (
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <PrimaryButton text={'Apply'} onClick={_onApply} />
                    <DefaultButton text={'Cancel'} onClick={() => props.onCancel()} />
                </Stack>
            )}
        >
            <Stack tokens={{ childrenGap: 20 }} className={styles.container}>
                <DatePicker
                    label="Start Date"
                    placeholder="Select start date..."
                    value={startDate}
                    formatDate={GeneralService.formatDate}
                    onSelectDate={(date) => setStartDate(date || undefined)}
                />
                <DatePicker
                    label="End Date"
                    placeholder="Select end date..."
                    value={endDate}
                    formatDate={GeneralService.formatDate}
                    onSelectDate={(date) => setEndDate(date || undefined)}
                />
            </Stack>
        </Panel>
    );
};

export default DateFilterPanel;
